import styled from "styled-components";

export const Wrapper = styled.div`
  margin-bottom:1.25rem;
  width:100%;
  font-family:Roboto,sans !important;

  .icon.partial {
    vertical-align: middle;
    display: inline-block;
    background: url(/partial-icon.svg) no-repeat;    
  }

  h4.partial-heading {
    background-color: #ededed;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    font-size: 14px;
    margin-bottom: 0;
    font-family:Roboto,sans !important;
    color: #5e6d73;
    font-weight:bold;
  }

  ul {
    padding: 0;
    margin-top: 10px;    
  }

  li {
    background-color: #f8f9f9;
    list-style-type: none;
    border-radius: 5px;
    padding-bottom:1rem;

    &.partial-group {
      margin-bottom:10px;
    }

    h5 {
      margin: 0;
      padding: 1rem 0 0 1rem;
      font-family:Roboto,sans !important;
      color:#5e6d73;
    }

    .cols {
      display:flex;
      justify-content: space-between;
    }
  }
  
`;


// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/components/DebriefDashboard/components/PartialList/style.js